import { API } from "../../allApi";
import { haveToApiService } from "../../plugins/axios";
import {
  ScratchCardResources,
  ScratchCardApiInterface,
  PurchaseScratchCardPayload,
  ScratchCardIdPayload,
} from "./types";

const SCRATCH_CARD_ENDPOINTS: ScratchCardResources = {
  PURCHASE_SCRATCH_CARD: {
    URL: API.PURCHASE_SCRATCH_CARD.URL,
    METHOD: API.PURCHASE_SCRATCH_CARD.METHOD,
  },
  REVEAL_SCRATCH_CARD: {
    URL: API.REVEAL_SCRATCH_CARD.URL,
    METHOD: API.REVEAL_SCRATCH_CARD.METHOD,
  },
  SCRATCH_CARD_LIST: {
    URL: API.GET_SCRATCH_CARDS.URL,
    METHOD: API.GET_SCRATCH_CARDS.METHOD,
  },
  DETAIL_SCRATCH_CARD: {
    URL: API.DETAIL_SCRATCH_CARD.URL,
    METHOD: API.DETAIL_SCRATCH_CARD.METHOD,
  },
};

const HAVETOApi: ScratchCardApiInterface = {
  purchaseScratchCard: async (payload: PurchaseScratchCardPayload) => {
    const { response, error } = await haveToApiService({
      resource: SCRATCH_CARD_ENDPOINTS.PURCHASE_SCRATCH_CARD,
      headers: { Authorization: `Bearer ${localStorage.getItem("authToken")}` },
      options: {
        data: {
          amount: payload.amount,
        },
      },
    });
    if (error) {
      return { error: error.message, scratchcard: null };
    } else {
      return {
        scratchcard: response,
        error: null,
      };
    }
  },
  revealScratchCard: async (payload: ScratchCardIdPayload) => {
    const { response, error } = await haveToApiService({
      resource: SCRATCH_CARD_ENDPOINTS.REVEAL_SCRATCH_CARD,
      headers: { Authorization: `Bearer ${localStorage.getItem("authToken")}` },
      options: {
        pathVars: { card_id: payload.card_id },
      },
    });
    if (error) {
      return { error, scratchcard: null };
    } else {
      return {
        scratchcard: response,
        error: null,
      };
    }
  },
  getScratchCardList: async () => {
    const { response, error } = await haveToApiService({
      resource: SCRATCH_CARD_ENDPOINTS.SCRATCH_CARD_LIST,
      headers: { Authorization: `Bearer ${localStorage.getItem("authToken")}` },
    });
    if (error) {
      return { error, scratchCardList: null };
    } else {
      return {
        scratchCardList: response,
        error: null,
      };
    }
  },
  getScratchCardDetail: async (payload: ScratchCardIdPayload) => {
    const { response, error } = await haveToApiService({
      resource: SCRATCH_CARD_ENDPOINTS.DETAIL_SCRATCH_CARD,
      headers: { Authorization: `Bearer ${localStorage.getItem("authToken")}` },
      options: {
        pathVars: { card_id: payload.card_id },
      },
    });
    if (error) {
      return { error, scratchcard: null };
    } else {
      return {
        scratchcard: response,
        error: null,
      };
    }
  },
};

export default HAVETOApi;

export { SCRATCH_CARD_ENDPOINTS };
